/** The mockup's pivots, as container widths so the portal's phone-width preview reflows too. */
export const BREAKPOINTS = {
  hero: 960,
  content: 900,
  plansTwoUp: 1080,
  plansOneUp: 620,
  navLinks: 780,
  mobile: 620,
} as const;

export const down = (px: number): string => `@container (max-width: ${px}px)`;
